import { type ReactElement } from 'react';

export function FRMAccountInsights(): ReactElement {
  return <div />;
}
